/* Research-informed routing defaults, not certified service-temperature ratings.
   Production review still checks the actual filament, casting chemistry and cure heat. */
(function () {
  'use strict';
  var defaults = {wax:'ASA',plaster:'PETG',concrete:'PETG',resin:'ASA',kit:'PETG',cool:'PETG',hot:'ASA',coolMax:55,hotMax:80};
  function recommend(cast, mode, config) {
    var c=Object.assign({},defaults,config), t=cast.temperatureC;
    var out={filament:'',reason:'',issue:'',review:''};
    if(t!==null && (!Number.isFinite(t)||t<0||t>300)) {
      out.issue='Enter a pouring temperature from 0 to 300°C, or leave it blank for advice.';return out;
    }
    if(mode==='silicone') {
      out.filament=c.kit;
      out.reason='Selected for the printed master and box used with room-temperature curing silicone. Your final casting goes into the silicone mold, not these printed parts. Heated silicone curing needs advice.';
      return out;
    }
    if(!Number.isFinite(c.coolMax)||!Number.isFinite(c.hotMax)||c.coolMax<0||c.hotMax<=c.coolMax) {
      out.issue='Please request a reviewed quote while we check the mold material settings.';return out;
    }
    var key={'Candle wax':'wax','Plaster':'plaster','Concrete':'concrete','Resin':'resin'}[cast.material];
    if(!key){out.issue='Please request advice for this casting material.';return out;}
    out.filament=c[key];
    if(t!==null && t>c.coolMax && out.filament.trim().toUpperCase()===c.cool.trim().toUpperCase()) out.filament=c.hot;
    out.reason=key==='wax'?'Selected for wax pouring. We check the wax product, release method and pouring temperature before printing.':key==='resin'?'Provisional choice for the estimate. Resin chemistry, pour depth and curing heat need checking before a direct printed mold can be ordered.':'Selected for '+cast.material.toLowerCase()+' casting. We check curing heat, mold release and the actual filament before printing.';
    if(t!==null && t>c.hotMax) out.issue='This pour is above our '+c.hotMax+'°C automatic selection limit. Request a reviewed quote or choose a silicone preparation kit.';
    if(key==='resin') out.review='Resin molds need a reviewed quote before checkout. Tell us the resin product and pour depth using “Ask about this material”.';
    else if(key==='wax' && t===null) out.review='Enter your wax pouring temperature before checkout, or ask us to review the project.';
    return out;
  }
  function attach(root,api,mold) {
    var panel=root.querySelector('[data-iq-material-panel]'), box=root.querySelector('[data-mold-material-summary]');
    var choices=Array.from(api.els.materials.querySelectorAll('input[type="radio"]'));
    var prior=null, active=false, signature='';
    var config={};Object.keys(defaults).forEach(function(key){
      var value=box.dataset[key];config[key]=key.endsWith('Max')?Number(value||defaults[key]):(value||defaults[key]);
    });
    function sync(){
      var enabled=api.state.moldEnabled;
      panel.hidden=enabled;box.hidden=!enabled;
      if(!enabled){
        api.state.moldMaterialIssue='';api.state.moldMaterialReview='';api.state.moldMaterialSelection=null;
        if(active){choices.forEach(function(input){input.checked=input===prior;});api.resetQuote();api.drawModel();}
        active=false;signature='';api.refreshEligibility();return;
      }
      if(!active){prior=choices.find(function(input){return input.checked;})||null;active=true;}
      var cast,decision;
      try{cast=mold.casting();decision=recommend(cast,mold.settings().mode,config);}
      catch(error){decision={filament:'',reason:'',issue:error.message,review:''};}
      var target=choices.find(function(input){return input.value.trim().toUpperCase()===decision.filament.trim().toUpperCase();});
      if(decision.filament&&!target)decision.issue='The recommended '+decision.filament+' is not currently available for an automatic quote. Ask us about this material.';
      var next=JSON.stringify([cast,mold.settings().mode,decision,target?choices.indexOf(target):-1]);
      choices.forEach(function(input){input.checked=input===target;});
      api.state.moldMaterialIssue=decision.issue;api.state.moldMaterialReview=decision.review;
      api.state.moldMaterialSelection={filament:decision.filament,colour:target?target.dataset.colourName:'',reason:decision.reason,review:decision.review,issue:decision.issue};
      box.querySelector('[data-mold-material-name]').textContent=target?target.value+(target.dataset.colourName?' · '+target.dataset.colourName:''):'Material review needed';
      box.querySelector('[data-mold-material-reason]').textContent=decision.issue||decision.reason;
      box.querySelector('[data-mold-material-review]').textContent=decision.issue?'':decision.review;
      if(next!==signature){signature=next;api.resetQuote();root.querySelector('[data-mold-ack]').checked=false;api.drawModel();}
      api.refreshEligibility();
    }
    return {sync:sync};
  }
  window.HiveMoldMaterial={recommend:recommend,attach:attach};
})();
